import IResult, { ResultType } from './IResult';

export default class OfflineResult<T> implements IResult<T> {
    data: T | undefined;
    resultType: ResultType = 'Offline';
    errors: string[];

    constructor() {
        this.errors = ['Network is offline. Please check your connection.'];
    }
}
